export class Orario {
	data: Date;
	oraDa: number = 10;
	minutiDa: number = 0; 
	oraA: number = 10;
	minutiA: number = 0;

	constructor () {}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/orario.ts